export enum LoadStatus {
	LOADING = 'loading',
	SET = 'set',
	UNSET = 'unset'
}